import { Modal, Tabs, Form, Input, Button, message } from "antd";
import type { FC } from "react";
import { UserInterface } from "../../../interface/user.interface";
import { updateProfile, changePassword } from "../../../api/user.api";
interface UserInfoModalProps {
  open: boolean;
  onClose: () => void;
  user?: UserInterface | null;
}

const UserInfoModal: FC<UserInfoModalProps> = ({ open, onClose, user }) => {
  const [form] = Form.useForm();

  const handleUpdateInfo = async (values: any) => {
    try {
      const { name, ...payload } = values;
      await updateProfile(payload);
      message.success("Cập nhật thành công");
      onClose();
    } catch (error: any) {
      message.error("Cập nhật thất bại");
    }
  };

  const handleChangePassword = async (values: any) => {
    try {
      await changePassword(values);
      message.success("Cập nhật mật khẩu mới thành công");

      // Xoá token và chuyển về login
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      onClose();
      setTimeout(() => {
        window.location.href = "/login";
      }, 1000); // Delay nhẹ để hiển thị message
    } catch (error: any) {
      message.error("Cập nhật mật khẩu mới thất bại");
    }
  };

  return (
    <Modal
      open={open}
      title="Thông tin tài khoản"
      onCancel={onClose}
      footer={null}>
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab="Thông tin cá nhân" key="1">
          <Form
            layout="vertical"
            form={form}
            onFinish={handleUpdateInfo}
            initialValues={user || {}}>
            <Form.Item
              label="Tên người dùng"
              name="name"
              rules={[{ required: true }]}>
              <Input disabled />
            </Form.Item>
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, type: "email" }]}>
              <Input />
            </Form.Item>
            <Form.Item style={{ textAlign: "center" }}>
              <Button type="primary" htmlType="submit">
                Cập nhật
              </Button>
            </Form.Item>
          </Form>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Đổi mật khẩu" key="2">
          <Form layout="vertical" onFinish={handleChangePassword}>
            <Form.Item
              label="Mật khẩu cũ"
              name="oldPassword"
              rules={[{ required: true }]}>
              <Input.Password />
            </Form.Item>
            <Form.Item
              label="Mật khẩu mới"
              name="newPassword"
              rules={[{ required: true }]}>
              <Input.Password />
            </Form.Item>
            <Form.Item
              label="Xác nhận mật khẩu mới"
              name="confirmPassword"
              dependencies={["newPassword"]}
              hasFeedback
              rules={[
                { required: true, message: "Vui lòng xác nhận mật khẩu mới" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("newPassword") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject("Mật khẩu xác nhận không khớp");
                  },
                }),
              ]}>
              <Input.Password />
            </Form.Item>
            <Form.Item style={{ textAlign: "center" }}>
              <Button type="primary" htmlType="submit">
                Đổi mật khẩu
              </Button>
            </Form.Item>
          </Form>
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  );
};

export default UserInfoModal;
